<template>
    <Sidebar class="sidebar slider" v-model:visible="visibleRight" position="right" :style="{ width: sidebarWidth }"
        :closable="true">

        <template #header>
            <div class="sidebar-header-content">
                <p class="bold-heading">{{ $t('Quotes.Details') }}</p>
                <p><i @click="closeFunction" class="pi pi-times pt-3" style="font-size: 1.5rem; color: #000000;"></i>
                </p>
            </div>
        </template>
        <div class="sidebar-container d-flex">
            <div class="Details-container" style="width: 23rem !important;">
                <b-row>
                    <b-col>
                        <div class="d-flex">

                            <h6 class="bold-heading common-heading mt6 ms-1">#78687hj</h6>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-row class="mt-3">
                            <b-col>
                                <p class="storecode">{{ $t('Quotes.logdate') }}</p>
                            </b-col>
                            <b-col>
                                <p class="bold-heading  float-end">22-dec-2023</p>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <p class="storecode">{{ $t('Quotes.validTill') }}</p>
                            </b-col>
                            <b-col>
                                <p class="bold-heading float-end">22-dec-2023</p>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <p class="storecode">{{ $t('Quotes.requestQuote') }} </p>
                            </b-col>
                            <b-col>
                                <p class="bold-heading  float-end">22-dec-2023</p>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <div class="blue mt-3">
                            <p>{{ $t('Quotes.Request') }}</p>
                        </div>
                    </b-col>
                    <b-col>
                        <div class="blue mt-3">
                            <p @click="RevisedQuote">{{ $t('Quotes.Amend') }}</p>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <div class="box mt-3 ms-3 me-3 pb-5">
                        <p class="bold-heading pt-3">{{ $t('Quotes.Amended') }}</p>
                        <div class="box-nested ps-3">
                            <b-row>
                                <b-col>
                                    <p class="bold-heading pt-3">#Q458244JI<span
                                            class="pi pi-window-maximize float-end pe-3" style="color: #3096FF"></span>
                                    </p>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <div class=" pb-3">
                                        <p class="storecode">{{ $t('Quotes.logdate') }}<span
                                                class="bold-heading ms-3">12
                                                DEC
                                                2022</span>
                                        </p>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                    </div>
                </b-row>
                <b-row>
                    <div class="box-heading d-flex">
                        <div>
                            <p class="storecode">{{ $t('5005.supplier') }}</p>
                        </div>
                        <div>
                            <p class="storecode">{{ $t('Supppliers.Cheapest') }}</p>
                        </div>
                        <div>
                            <p class=storecode>{{ $t('Supppliers.New') }}</p>
                        </div>
                    </div>
                </b-row>
                <b-row>
                    <div class="box-nested2 mt-3 me-3 ms-3 ">
                        <b-row>
                            <b-col>
                                <p class="storecode pt-3">#Q458244JI <span class="pi pi-window-maximize float-end pe-3"
                                        style="color: #3096FF"></span>
                                </p>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <div class="pb-3">
                                    <p class="bold-heading">Medplus Emergency</p>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                </b-row>
                <div class="summary mt-3">
                    <b-row>

                        <p class="storecode">{{ $t('Quotes.summary') }}</p>
                    </b-row>
                    <b-row>
                        <div class="summary-details mt-3">

                            <div class="amount">
                                <div>
                                    <p class="storecode">{{ $t('5005.tax.tax') }}</p>
                                    <p class="storecode">{{ $t('5005.paymentterms.discount') }}</p>
                                </div>
                                <div>
                                    <p class="bold-heading">2345</p>
                                    <p class="bold-heading">45.6%</p>
                                </div>

                            </div>

                            <div class="committed d-flex ">
                                <div class="committed1">
                                    <p class="bold-heading">10/10</p>
                                    <p class="storecode">{{ $t('StoreMasterDetails.ItemsInfo.committed') }}</p>
                                </div>
                                <div class="value">
                                    <p class="bold-heading">10.43</p>
                                    <p class="storecode">{{ $t('StoreMasterDetails.ItemsInfo.Value') }}</p>
                                </div>
                            </div>
                        </div>
                    </b-row>
                    <b-row>
                        <b-col>
                            <p class="storecode mt-3">{{ $t('Quotes.breakup') }}</p>
                        </b-col>
                        <b-col>
                            <div class="blue mt-3">
                                <p @click="showDetails" class="float-end">{{ $t('Quotes.ViewDetails') }}</p>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <Tableview :value="items" :paginator="true" class="p-datatable-gridlines" :rows="10"
                            :rowHover="true" filterDisplay="menu" responsiveLayout="scroll" :columns="headers"
                            :globalFilterFields="globalFilterFields" :filters="filters" selectionMode="single"
                            :templateheaderhide="false">

                        </Tableview>
                    </b-row>
                </div>
                <div>
                    <b-row>
                        <p class="storecode mt-3 ">{{ $t('5005.paymentterms.terms') }}</p>
                    </b-row>
                    <b-row>
                        <p class="terms">{{ $t('Quotes.payterms') }}</p>
                    </b-row>
                    <b-row>
                        <p class="storecode mt-3 ">{{ $t('5005.DeliveryTerms') }}</p>
                    </b-row>
                    <b-row>
                        <p class="terms">{{ $t('Quotes.delterms') }}</p>
                    </b-row>
                    <b-row>
                        <p class="storecode mt-5">{{ $t('storetab.logs') }}</p>

                    </b-row>
                    <b-row>
                        <div class="border-box ms-3">
                            <p><span class="pi pi-check-circle"></span>{{ $t('Quotes.logs1') }}</p>
                            <p class="storecode float-end">14 Dec 2022 | 05:03</p>
                        </div>
                    </b-row>
                    <b-row>
                        <div class="border-box mt-3 ms-3">
                            <p><span class="pi pi-check-circle"></span>{{ $t('Quotes.logs2') }} <span
                                    class="blue-text">#RET6451</span>
                                {{ $t('Quotes.logs3') }}<span>VimalRaj</span></p>
                            <p class="storecode float-end">14 Dec 2022 | 05:03</p>
                        </div>
                    </b-row>
                </div>
            </div>
            <div class="DetailsTable ms-5" style="width: 23rem !important;" v-if="showDetailsTable">
                <b-row>
                    <b-col>
                        <p class="bold-heading common-heading1">{{ $t('ItemDetails.title') }}</p>
                    </b-col>
                </b-row>
                <b-row>
                    <Tableview :value="items1" :paginator="true" class="p-datatable-gridlines" :rows="10"
                        :rowHover="true" filterDisplay="menu" responsiveLayout="scroll" :columns="DetailsTableheaders"
                        :globalFilterFields="globalFilterFields" :filters="filters" selectionMode="single"
                        :templateheaderhide="false">

                    </Tableview>
                </b-row>

            </div>
        </div>

    </Sidebar>
</template>

<script lang="ts">
import { defineComponent, ref, reactive } from 'vue';

;
import { GChart } from "vue-google-charts";
import Tableview from "../../../../../../components/FormComponents/Table.vue";
import { useI18n } from 'vue-i18n';
import { FilterMatchMode, FilterOperator } from "primevue/api";
//TableComponent

import { emit } from 'process';
//Component
import RackBoxMapping from '../../../../../../modules/Inventory/components/Sidebar/RightSidebar/component/RackBoxMapping.vue';
import Pricing from '../../../../../../modules/Inventory/components/Sidebar/RightSidebar/component/Pricing.vue';


export default defineComponent({
    components: {

        GChart,
        //Table Component
        //component
        Tableview,
        RackBoxMapping,
        Pricing,
    },
    props: {
        trigger: {
            type: Boolean,
            default: false
        },
        visibleRight: {
            type: Boolean,
            default: false
        }
    },
    setup(props, { emit }) {
        const { t } = useI18n();
        const active = ref(true);
        const sidebarWidth = ref('26rem');
        const showDetailsTable = ref(false);

        const placement = ref('right')
        const data = [
            ['Element', 'Density', { role: 'style' }],
            ['Print Media', 9.95, '#dab8a7'],
            ['Social Media', 55.55, '#dab8a7'],
            ['Brodcast Media', 52.99, '#dab8a7'],
            ['Outdoor', 30.55, 'color: #dab8a7'],
            ['Internet', 45.21, 'color: #dab8a7']
        ]
        const options = {
            width: 285,
            height: 200
        }
        let items = ref([
            { RowNumber: 'DOLO 650', ID: 1001, Name: '4303' },
            { RowNumber: 'DOLO 650', ID: 1002, Name: 'Product B' },
            { RowNumber: 'DOLO 650', ID: 1003, Name: 'Product C' }

        ])
        let items1 = ref([
            { RowNumber: 1, Req: 10, ID: 1001, free: 5, unitcost: 10, Discount: 2, Tax: 1, Totalvalue: 100 },
            { RowNumber: 2, Req: 15, ID: 1002, free: 3, unitcost: 12, Discount: 1, Tax: 1, Totalvalue: 150 },
            { RowNumber: 3, Req: 20, ID: 1003, free: 8, unitcost: 8, Discount: 3, Tax: 2, Totalvalue: 160 }

        ])

        //DataTable Fields
        const DetailsTableheaders = [
            {
                header: "Items",
                field: "RowNumber",
                class: 'width60',
            },
            {
                header: "Req quantity",
                field: "Req",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                class: 'width60',
            },
            {
                header: "Committed quantity",
                field: "ID",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                class: 'width60',
            },
            {
                header: "Free",
                field: "free",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
            },
            {
                header: "Unit cost",
                field: "unitcost",
                class: 'width150'
            },
            {
                header: "Discount",
                field: "Discount",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
            },
            {
                header: "Tax",
                field: "Tax",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
            },
            {
                header: "Total value",
                field: "Totalvalue",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
            },
        ]
        const headers = [
            {
                header: "Items",
                field: "RowNumber",
                class: 'width150'
            },
            {
                header: "Committed quantity",
                field: "ID",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
            },
            {
                header: "Total value",
                field: "Name",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
            },
        ];
        const globalFilterFields = ref(headers.map((col) => col.field));
        const filters = {
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            TaxName: { value: null, matchMode: FilterMatchMode.IN, options: items },
            TaxType: { value: null, matchMode: FilterMatchMode.IN, options: items },
            TaxSubType: {
                value: null,
                matchMode: FilterMatchMode.IN,
                options: items,
            },
            ActiveStatus: {
                value: null,
                matchMode: FilterMatchMode.IN,
                options: items,
            },
        };
        const showDetails = () => {
            debugger;
            sidebarWidth.value = sidebarWidth.value == '50rem' ? '26rem' : '50rem';
            showDetailsTable.value = true;
        }
        const RevisedQuote = () => {
            router.push({
                path: "/ReviseQuoteForm",
            })
        }
        const closeFunction = () => {
            emit('close')
            sidebarWidth.value = sidebarWidth.value = '26rem';
        }

        return {
            showDetailsTable,
            filters,
            items,
            closeFunction,
            data,
            options,
            active,
            placement,
            globalFilterFields,
            headers,
            items1,
            DetailsTableheaders,
            showDetails,
            sidebarWidth,
            RevisedQuote
        }
    }

})
</script>

<style lang="scss" scoped>
@import "../../../../../../assets/variables.scss";

.p-sidebar-header-content {
    width: 100%;
}

.amount {
    width: 120px;
    display: flex;
    justify-content: space-between;
}

.sidebar-header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.blue p {
    color: $BackToMaster;
    font-size: 12px;
}

.box {
    background-color: #FEECDE;
    border-radius: 10px;
    width: 95% !important;
}

.terms {
    font-size: 12px;
}

.box-nested,
.box-nested2 {
    background-color: #FFFFFF;
    border-radius: 10px;
}

.box-nested2 {
    border: 1px solid #b1abab;
    width: 95% !important;
}

.box-heading {
    justify-content: space-around;
    padding-top: 5%;
}

.summary-details {
    display: flex;
    justify-content: space-evenly;
}

.value {
    background-color: #EAECF1;
    width: 100px;
    border-radius: 10px;
    text-align: center;
}


.committed1 {

    width: 100px;
    opacity: 1;
    border-radius: 10px;
    text-align: center;
}

// .Details-container {
//     width: 17rem !important;
// }

// .DetailsTable {
//     width: 25rem !important;
// }

.p-sidebar-right .p-sidebar {
    width: auto;
    height: 100%;
}


.border-box {
    border: 1px solid #b1abab;
    border-radius: 10px;
    width: 95% !important;

    p {
        padding: 10px 0px;
        font-size: 13px;
    }

    .blue-text {
        color: #3096FF
    }
}
</style>
